import React from 'react';
import PropTypes from 'prop-types';
import StyledModuleContainer from './ModuleContainer.style';

const ModuleContainer = ({
  mobileBackgroundImage,
  backgroundImage,
  fill,
  children
}) => {
  return (
    <StyledModuleContainer
      mobileBackgroundImage={mobileBackgroundImage || backgroundImage}
      backgroundImage={backgroundImage}
      fill={fill && fill.toString()}
      data-testid="module-container"
    >
      {children}
    </StyledModuleContainer>
  );
};

ModuleContainer.propTypes = {
  mobileBackgroundImage: PropTypes.string,
  backgroundImage: PropTypes.string,
  fill: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.node
  ])
};

export default ModuleContainer;



// WEBPACK FOOTER //
// ./src/components/ModuleContainer/ModuleContainer.js